// @Vendors
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';


class LoginTemplate extends Component {
  render() {
    const { children } = this.props;
    return (
      <div id="app_login">
        <section id='temp_login'>
          {children}
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const actions = {};

export default withRouter(
  connect(
    mapStateToProps,
    actions
  )(LoginTemplate)
);



// WEBPACK FOOTER //
// ./src/pages/App/Templates/LoginTemplate.js